module.exports = __webpack_public_path__ + "static/media/ios_tips_05.4561944e.png";